import { render } from "./BannerWarning.vue?vue&type=template&id=60ea77b4"
import script from "./BannerWarning.vue?vue&type=script&lang=js"
export * from "./BannerWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__